<template>
  <div class="packresults">
    <slot name="pre-pack">
      <div class="markdown" v-html="$options.filters.parseMd(prePack)" />
    </slot>
    <slot name="pack-widget">
      <client-only>
        <TabCard :tabs="tabs" :initial-tab="selectedTab" @pack="loadAndPackRecipe()">
          <template slot="tab-head-visual">
            Visual
          </template>
          <template slot="tab-panel-visual">
            <h2 v-if="!response" class="title">Click "Pack it" to load.</h2>
            <div v-if="loading" style="padding-top: 8em; color: #FFF;">
              Loading
            </div>
            <!-- eslint-disable -->
              <recipe-svgs v-if="response" :svgs="svgs" :boxes="boxes"/>
              <br style="clear: both;">
          <!-- eslint-enable -->
          </template>
          <template slot="tab-head-request">
            Request
          </template>
          <template slot="tab-panel-request">
            <pre>{{ payload }}</pre>
          </template>
          <template slot="tab-head-response">
            Response
          </template>
          <template slot="tab-panel-response">
            <div v-if="response">
              <pre> {{ response }} </pre>
            </div>
          </template>
        </TabCard>
      </client-only>
    </slot>
    <slot name="post-pack">
      <div class="markdown" v-html="$options.filters.parseMd(postPack)" />
    </slot>
  </div>
</template>
<script>
import { recipeBase } from '~/components/recipes/mixins/base'

export default {
  name: 'Recipe',
  mixins: [recipeBase]
}

</script>

<style scoped>
  pre{
  color: #f1f1f1;
  background: #444;
  }
</style>
